import { v4 as uuidv4 } from 'uuid';

import { toDayCodes } from './coverageHoursRowFormat';
import { minutesToTimeIso } from './coverageHoursTimeUtils';
import { TeamCoverageEntry } from './coverageHoursTeamUtils';
import { toTeamId } from './useCoverageHours';

export type CoverageHoursPair = {
  routingId: string;
  teams: TeamCoverageEntry[];
};

export type WireBlock = {
  id: string;
  teamId: string | null;
  teamName: string | null;
  daysOfWeek: string[];
  startMinute: number;
  endMinute: number;
  timezone: string | null;
  __typename?: string;
};

export type WireRouting = {
  routingId: string;
  category: string;
  issue: string | null;
  blocks: WireBlock[];
  __typename?: string;
};

// Blocks are already grouped by team+days+time window on the server; this only
// regroups them by team so each team keeps its own list of blocks.
export function toTeams(blocks: WireBlock[]): TeamCoverageEntry[] | null {
  const teams = new Map<string, TeamCoverageEntry>();

  for (const block of blocks) {
    const teamId = toTeamId(block.teamId);

    if (!teamId) {
      return null;
    }

    const team = teams.get(teamId) ?? {
      id: uuidv4(),
      teamId,
      teamLabel: block.teamName ?? '',
      coverageBlocks: [],
    };

    team.coverageBlocks.push({
      daysOfWeek: toDayCodes(block.daysOfWeek),
      startTime: minutesToTimeIso(block.startMinute),
      endTime: minutesToTimeIso(block.endMinute),
    });
    teams.set(teamId, team);
  }

  return [...teams.values()];
}

export function toCoverageHoursPair(
  routing: WireRouting | null | undefined
): CoverageHoursPair | null {
  if (!routing) {
    return null;
  }

  const teams = toTeams(routing.blocks);

  if (!teams) {
    return null;
  }

  return { routingId: routing.routingId, teams };
}
